import React from "react";
import { stringToColor } from "../../data/Constants";
import { BodyBuilder } from "../../exports/Images";
import {
  convertStraight,
  convertTo12HourFormat,
} from "../common-data/Converts";
import {
  BiTelephoneForwardFillIcon,
  EmailIcon,
  LocationIcon,
  TrainerIcon1,
} from "../../images/icons/icons";
import { trainer_bca_evaluation_filter_types } from "../common-data/DropdowData";

const DetailModHeader = ({ info, onClose, isOnlySubscription, from, filterType }) => {
  const name = info?.name || info?.user_name || "",
    profile = info?.profile || info?.user_profile || "",
    mobile = info?.mobile || info?.user_mobile || "",
    email = info?.email || info?.user_email || "";

  const shiftDetails1 = info?.shift_details ? info.shift_details?.[0] : {};
  const startTime1 = shiftDetails1?.start_time
    ? convertTo12HourFormat(shiftDetails1.start_time)
    : "";
  const endTime1 = shiftDetails1?.end_time
    ? convertTo12HourFormat(shiftDetails1.end_time)
    : "";

  const shiftDetails2 =
    info?.shift_details?.length > 1 ? info.shift_details?.[1] : {};
  const startTime2 = shiftDetails2?.start_time
    ? convertTo12HourFormat(shiftDetails2.start_time)
    : "";
  const endTime2 = shiftDetails2?.end_time
    ? convertTo12HourFormat(shiftDetails2.end_time)
    : "";

  return (
    <div className="modalHeadAndCloseContainer mod-with-details">
      <div className="user-info">
        {from === "tme-analysis" ? (
          <div className="user-details tme-analysis">
            <span className="mod-header">
              <TrainerIcon1 color="#000" />
              {info?.trainer_name || "NA"}
            </span>
            <span className="mod-regular-text underline">
              <BiTelephoneForwardFillIcon color="#000" />
              +91 {info?.trainer_mobile || ""}
            </span>
            <span className="mod-regular-text lowercase underline">
              <EmailIcon color="#000" />
              {info?.trainer_email || ""}
            </span>
            <span className="mod-light-text">
              <LocationIcon color="#000" /> {info?.gym_name || ""}
            </span>
            {filterType && (
              <span
                className="mod-padded-highlighted-text"
                style={{
                  backgroundColor: "#EBE8FE",
                  color: "#0C0B0B",
                }}
              >
                {trainer_bca_evaluation_filter_types.find(
                  (item) => item.value === filterType
                )?.label || filterType}
              </span>
            )}
          </div>
        ) : (
          <>
            {!isOnlySubscription ? (
              <div className="user-img">
                {profile ? (
                  <img
                    src={profile || BodyBuilder}
                    alt={name || "N/A"}
                    className="image"
                  />
                ) : (
                  <div
                    className="nameInitials"
                    style={{
                      backgroundColor: stringToColor(name || ""),
                    }}
                  >
                    <span className="nameLetters">
                      <span className="nameLetters">
                        {name
                          ?.split(" ")
                          .map((namePart, index) =>
                            index === 0 || index === name?.split(" ").length - 1
                              ? namePart.charAt(0).toUpperCase()
                              : null
                          )}
                      </span>
                    </span>
                  </div>
                )}
              </div>
            ) : null}

            <div className="user-details">
              <span className="mod-header">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="33"
                  height="33"
                  viewBox="0 0 33 33"
                  fill="none"
                  onClick={onClose}
                >
                  <g id="navigate_before">
                    <path
                      id="icon"
                      d="M19.25 24.75L11 16.5L19.25 8.25L21.175 10.175L14.85 16.5L21.175 22.825L19.25 24.75Z"
                      fill="#1D1B20"
                    />
                  </g>
                </svg>{" "}
                {name || "NA"}
              </span>
              <span className="mod-regular-text underline">
                +91 {mobile || ""}
              </span>
              <span className="mod-regular-text lowercase underline">
                {email || ""}
              </span>
              <span className="mod-light-text">{info?.gym_name || ""}</span>
              {info?.trainer_name && (
                <span className="mod-light-text">
                  <b>Current Trainer: </b>
                  {info.trainer_name || ""}
                </span>
              )}

              {!isOnlySubscription ? (
                <>
                  <span className="mod-highlighted-text">
                    Joined on:{" "}
                    <b>
                      {info?.joining_date
                        ? convertStraight(info.joining_date)
                        : "-"}
                    </b>
                  </span>
                  <span className="mod-highlighted-text">
                    Shift Details:{" "}
                    <b>
                      {startTime1} - {endTime1}
                      {startTime2 && endTime2
                        ? ` / ${startTime2} - ${endTime2}`
                        : ""}
                    </b>
                  </span>
                  <span
                    className={`mod-padded-highlighted-text`}
                    style={{
                      backgroundColor:
                        info?.account_type === "receptionist"
                          ? "#EBE8FE"
                          : "#FEF0E8",
                      color: "#0C0B0B",
                    }}
                  >
                    {info?.account_type === "receptionist" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_18194_6249)">
                          <path
                            d="M8.1905 6.26968C9.46501 6.26968 10.4982 5.23649 10.4982 3.96199C10.4982 2.68749 9.46501 1.6543 8.1905 1.6543C6.916 1.6543 5.88281 2.68749 5.88281 3.96199C5.88281 5.23649 6.916 6.26968 8.1905 6.26968Z"
                            stroke="#0C0B0B"
                            strokeWidth="1.53846"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M13.1914 11.6547V10.5778C13.1914 9.88552 12.8068 9.19321 12.1145 8.88552C10.9606 8.19321 9.57602 7.88552 8.19141 7.80859C6.80679 7.80859 5.42218 8.19321 4.26833 8.88552C3.65294 9.19321 3.19141 9.88552 3.19141 10.5778V11.6547"
                            stroke="#0C0B0B"
                            strokeWidth="1.53846"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M3.19081 15.4997L3.96004 19.3459M17.8062 15.4997L17.037 19.3459M15.4985 11.6535V11.2689C15.4985 10.6535 16.037 10.1151 16.6523 10.1151M16.6523 10.1151C17.2677 10.1151 17.8062 10.6535 17.8062 11.2689V11.6535M16.6523 10.1151V9.73047M2.80619 11.6535H18.1908C18.8062 11.6535 19.3447 12.192 19.3447 12.8074V14.3459C19.3447 14.9612 18.8062 15.4997 18.1908 15.4997H2.80619C2.19081 15.4997 1.65234 14.9612 1.65234 14.3459V12.8074C1.65234 12.192 2.19081 11.6535 2.80619 11.6535Z"
                            stroke="#0C0B0B"
                            strokeWidth="1.53846"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_18194_6249">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                              transform="translate(0.5 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <path
                          d="M18.0003 6.92509C17.4692 6.27984 16.8009 5.76105 16.0441 5.40644C15.2873 5.05184 14.461 4.87032 13.6253 4.87509H3.62531C3.12803 4.87509 2.65112 5.07264 2.29949 5.42427C1.94785 5.7759 1.75031 6.25281 1.75031 6.75009V9.46884C1.74228 9.91014 1.8902 10.3401 2.16801 10.6831C2.44582 11.0261 2.83571 11.2601 3.26906 11.3438L7.95031 12.2563C8.05384 12.2766 8.15055 12.3228 8.23142 12.3906C8.31229 12.4583 8.37469 12.5455 8.41281 12.6438C8.83398 13.6788 9.55576 14.5637 10.4849 15.1842C11.4141 15.8048 12.508 16.1325 13.6253 16.1251C13.9691 16.1246 14.3121 16.0932 14.6503 16.0313C15.7491 15.8307 16.7632 15.3074 17.5635 14.5283C18.3638 13.7491 18.914 12.7493 19.1441 11.6563C19.3158 10.8322 19.3023 9.98027 19.1045 9.16202C18.9067 8.34378 18.5296 7.57972 18.0003 6.92509ZM17.9441 11.3876C17.7741 12.2405 17.351 13.0223 16.73 13.631C16.109 14.2398 15.3189 14.6472 14.4628 14.8001C13.4703 14.9866 12.4438 14.824 11.5575 14.3398C10.6712 13.8557 9.97969 13.0798 9.60031 12.1438C9.48115 11.8491 9.289 11.5895 9.04191 11.3894C8.79482 11.1893 8.50091 11.0553 8.18781 11.0001L3.50656 10.0813C3.36211 10.0534 3.23215 9.97542 3.13954 9.8611C3.04694 9.74677 2.99763 9.60344 3.00031 9.45634V6.75009C3.00031 6.58433 3.06616 6.42536 3.18337 6.30815C3.30058 6.19094 3.45955 6.12509 3.62531 6.12509H6.75031V7.37509C6.75031 7.54085 6.81616 7.69982 6.93337 7.81703C7.05058 7.93424 7.20955 8.00009 7.37531 8.00009C7.54107 8.00009 7.70004 7.93424 7.81725 7.81703C7.93446 7.69982 8.00031 7.54085 8.00031 7.37509V6.12509H13.6253C14.2706 6.12541 14.9078 6.26847 15.4913 6.544C16.0748 6.81954 16.5901 7.22074 17.0003 7.71884C17.4151 8.22434 17.7122 8.81582 17.87 9.45038C18.0278 10.0849 18.0425 10.7467 17.9128 11.3876H17.9441Z"
                          fill="#0C0B0B"
                        />
                        <path
                          d="M13.625 7.375C13.0069 7.375 12.4027 7.55828 11.8888 7.90166C11.3749 8.24504 10.9744 8.7331 10.7379 9.30411C10.5014 9.87513 10.4395 10.5035 10.56 11.1097C10.6806 11.7158 10.9783 12.2727 11.4153 12.7097C11.8523 13.1467 12.4092 13.4444 13.0153 13.565C13.6215 13.6855 14.2499 13.6236 14.8209 13.3871C15.3919 13.1506 15.88 12.7501 16.2233 12.2362C16.5667 11.7223 16.75 11.1181 16.75 10.5C16.75 9.6712 16.4208 8.87634 15.8347 8.29029C15.2487 7.70424 14.4538 7.375 13.625 7.375ZM13.625 12.375C13.2542 12.375 12.8917 12.265 12.5833 12.059C12.275 11.853 12.0346 11.5601 11.8927 11.2175C11.7508 10.8749 11.7137 10.4979 11.786 10.1342C11.8584 9.77049 12.037 9.4364 12.2992 9.17417C12.5614 8.91195 12.8955 8.73337 13.2592 8.66103C13.6229 8.58868 13.9999 8.62581 14.3425 8.76773C14.6851 8.90964 14.978 9.14996 15.184 9.45831C15.39 9.76665 15.5 10.1292 15.5 10.5C15.5 10.9973 15.3025 11.4742 14.9508 11.8258C14.5992 12.1775 14.1223 12.375 13.625 12.375Z"
                          fill="#0C0B0B"
                        />
                      </svg>
                    )}

                    {info?.account_type === "receptionist"
                      ? "Sales Execuitives"
                      : "Trainer"}
                  </span>
                </>
              ) : null}
            </div>
          </>
        )}
      </div>

      <button type="button" className="closeModalBtn" onClick={onClose}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-x-lg"
          viewBox="0 0 16 16"
        >
          <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
        </svg>
      </button>
    </div>
  );
};

export default DetailModHeader;
